import { Create, SimpleForm } from 'react-admin'
import { UpsertCustomer } from '~/components'

const CustomerCreate = (props) => {
  return (
    <Create title='resources.customers.create' {...props} redirect='show'>
      <SimpleForm>
        <UpsertCustomer {...props} />
      </SimpleForm>
    </Create>
  )
}

export default CustomerCreate
